import { useOptionalSidePanelPresentation } from 'designSystem/components/sidePanelContext'
import { useAdvancedSearchUX } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import {
  getDocChatArtifactId,
  searchStateWithDocChatArtifact,
} from 'features/knowledgeDocumentViewer/utils/docChatPreview'
import { useCallback } from 'react'

/** The artifact shown in the chat side panel; persisted on the tab's docChat state. */
export function useAgenticChatArtifactPanel(): {
  artifactId: string | undefined
  isArtifactOpen: boolean
  openArtifact: (artifactId: string) => void
  closeArtifact: () => void
} {
  const { onSearchStateChange, searchState, siteId } = useAdvancedSearchUX()
  const sidePanel = useOptionalSidePanelPresentation()
  const docChat =
    searchState.docChat?.siteId === siteId ? searchState.docChat : undefined
  const artifactId = getDocChatArtifactId(docChat)

  const openArtifact = useCallback(
    (nextArtifactId: string) => {
      sidePanel?.keepOpenOnNextOutsideClick()
      onSearchStateChange((currentSearchState) =>
        searchStateWithDocChatArtifact(currentSearchState, nextArtifactId)
      )
    },
    [onSearchStateChange, sidePanel]
  )

  const closeArtifact = useCallback(() => {
    onSearchStateChange((currentSearchState) =>
      searchStateWithDocChatArtifact(currentSearchState, null)
    )
  }, [onSearchStateChange])

  return {
    artifactId,
    isArtifactOpen: artifactId !== undefined,
    openArtifact,
    closeArtifact,
  }
}
